export const SendExamLinkInitialValues = {
    examLevel: "",
    examName: "",
    percentage: "",
  };
  